import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  actionId: string;
  promptKey: string;
  slots: string[];
  onCancel: () => void;
  onSubmit: (filledPrompt: string) => void;
}

export function SlotFillForm({ actionId: _actionId, promptKey, slots, onCancel, onSubmit }: Props) {
  const { t } = useTranslation('console-ai');
  const [values, setValues] = useState<Record<string, string>>(
    () => Object.fromEntries(slots.map(s => [s, ''])),
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    let filled = t(promptKey);
    for (const [slot, val] of Object.entries(values)) {
      filled = filled.replaceAll(`{${slot}}`, val);
    }
    onSubmit(filled);
  };

  return (
    <div className="border-t border-white/10 p-4 bg-slate-800/50">
      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        <p className="text-xs text-slate-400 font-medium uppercase tracking-wide">Fill in template slots</p>
        {slots.map(slot => (
          <div key={slot} className="flex flex-col gap-1">
            <label className="text-xs text-slate-300 font-medium">{slot}</label>
            <input
              className="bg-white/5 border border-white/10 rounded px-2 py-1.5 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-sky-500"
              placeholder={`Enter ${slot}...`}
              value={values[slot] ?? ''}
              onChange={e => setValues(v => ({ ...v, [slot]: e.target.value }))}
            />
          </div>
        ))}
        <div className="flex items-center gap-2 justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="text-sm px-3 py-1.5 rounded border border-white/10 hover:bg-white/5 text-slate-300"
          >
            {t('templates.slotFill.cancel', 'Back')}
          </button>
          <button
            type="submit"
            className="text-sm px-3 py-1.5 rounded bg-sky-500 hover:bg-sky-600 text-white font-medium"
          >
            {t('templates.slotFill.submit', 'Use this')}
          </button>
        </div>
      </form>
    </div>
  );
}
